import { analytics } from 'config/segment'

export const useAnalytics = () => {
  return { ...analytics }
}
